import { Injectable } from '@angular/core';
import { Exercise } from './exercise.model';
import { Subject, Subscription } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable({
    providedIn: 'root'
})
export class TrainingService {
    
    exerciseChanged = new Subject<Exercise>();
    exercisesChanged = new Subject<Exercise[]>();
    finishedExercisesChanged = new Subject<Exercise[]>();
    private availableExercises: Exercise[] = [];
    private runningExcercise: Exercise;
    private fbSubs: Subscription[] = [];

    constructor(private db: AngularFirestore, private matSnackBar: MatSnackBar){}

    fetchAvailableExercises(){
        this.fbSubs.push(this.db.collection('availableExercises')
        .snapshotChanges()
        .pipe(
          map( docArr => {
            return docArr.map( doc => {
              return {
                id:doc.payload.doc.id,
                ...doc.payload.doc.data() as Exercise
              };
            });
          })
        ).subscribe( (exercises: Exercise[]) => {
            this.availableExercises = exercises;
            this.exercisesChanged.next([...this.availableExercises]);
        }, error => {
            this.matSnackBar.open('Fetching Exercises failed. Please try again later', null, {
                duration: 5000
            });
            console.log('error: ', error);
        }
        ));
    }

    startExercise(selectedId: string){
        //this.db.doc('availableExercises/' + selectedId).update({lastSelected: new Date() })
        const selectedExercise = this.availableExercises.find( ex => ex.id === selectedId);
        this.runningExcercise = selectedExercise;
        this.exerciseChanged.next({...this.runningExcercise});
    }

    getRunningExercise(){
        return { ...this.runningExcercise };
    }

    completeExercise(){
        this.addDataToDatabase({
            ...this.runningExcercise, 
            date: new Date(), 
            state:'completed'
         });
        this.runningExcercise = null;
        this.exerciseChanged.next(null);
    }

    cancelExercise(progress: number){
        this.addDataToDatabase({
            ...this.runningExcercise, 
            duration: this.runningExcercise.duration * (progress/100), 
            calories: this.runningExcercise.calories * (progress/100), 
            date: new Date(), 
            state: 'canceled' 
        });
        this.runningExcercise = null;
        this.exerciseChanged.next(null);
    }

    fetchCompletedOrCanceledExercises(){
        this.fbSubs.push(this.db.collection('finishedExercises').valueChanges().subscribe((exercises: Exercise[]) => {
            this.finishedExercisesChanged.next(exercises);
        }, ));
    }

    private addDataToDatabase(exercise: Exercise){
        this.db.collection('finishedExercises').add(exercise);
    }

    cancelSubscriptions(){
        this.fbSubs.forEach(sub => sub.unsubscribe());
    }
}